import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MessageEvent, HandleSideMenuWithAuth, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from '../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { LoyaltyService } from '../loyalty.service';
// import * as jsonexport from "jsonexport/dist"
@Component({
  selector: 'app-loyalty-summary-detail',
  templateUrl: './summary-detail.component.html',
  styleUrls: ['./summary-detail.component.css'],
  providers: [
    MessageEvent,
    SignInEvent,
    OpenFrameEvent,
    LoaderEvent,
    SidemenuSubCategory,
    HiddenFooter,
    SetAllMemberCheck,
    HandleSideMenuWithAuth
  ]
})
export class LoyaltySummaryDetailComponent implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  visitStats: any[] = [];
  isLoading = true;
  error = '';
  private memberVisitDetails = [];
  private vendor: any;
  spentDetails: any;
  memberDetails: any;
  dateJoined: any;
  endDate: any;
  startDate: any;

  timezoneOffset: any;
  private totalSizeOfList = 0;
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: 10
  };
  clubName: string = '';
  currentPage = 1;
  private popUpMessage = '';
  protected message = '';
  tableVariable: any = {};
  searchMember: any;
  private noMemberAvailable: boolean = true;
  private totalPage = 0;
  private noMemberAvailableInFilter = false;
  private noOfPageItem = 10;
  private exp = false;
  private rowItemSizes = [10];
  editRowIndex: number = -1;
  private height: any;


  private windowHeight = window.innerHeight;
  private topNav = 60;
  private midNav = 70;
  private footer = 35;
  private container = 40;
  private divHeight = 30;
  private scrollOptions: ISlimScrollOptions;
  private shouldSlide: boolean = false;
  constructor(private loaderEvent: LoaderEvent, private loyaltyService: LoyaltyService, private _router: Router, public messageEvent: MessageEvent) {
    this.scrollOptions = {
      barBackground: "#343a40",
      barOpacity: "0.6",
      position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px",
      gridBackground: "#adb5bd", gridOpacity: "1",
      gridWidth: "4", gridBorderRadius: "10",
      gridMargin: "1px 2px",
    };
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
    if (localStorage.getItem('vendor')) {
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.timezoneOffset = this.vendor.timezoneOffset * -1;
      this.clubName = this.vendor.clubName;
    }

  }

  ngOnInit() {

    this.startDate = new Date(localStorage.getItem('selectedStartDate'));
    this.endDate = new Date(localStorage.getItem('selectedEndDate'));

    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.clubName = this.vendor.clubName;
    this.pagination(this.pageOptions, 1);
  }

  getMemberVisitDetails(request) {
    try {
      this.loaderEvent.fire(false);
      let that = this;
      this.loyaltyService.getMemberVisitDetails(request).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.spentDetails = result.spentDetails;
          this.memberVisitDetails = result.data;
          this.dateJoined = result.memberSince;
          this.memberDetails = result.memberDetails;

          this.totalSizeOfList = result.total;
          this.noMemberAvailable = (result.total > 0);

          this.totalPage = Math.ceil(this.totalSizeOfList / this.noOfPageItem);
          if (this.memberVisitDetails.length === 0) {
            this.noMemberAvailable = false;
          } else {
            this.noMemberAvailable = true;
          }
          if (request['filters'].length > 0) {
            this.noMemberAvailableInFilter = true;
          } else {
            this.noMemberAvailableInFilter = false;
          }
          this.loaderEvent.fire(true);
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }
  }

  pageChangeClick(currentPage, noOfPageItem) {
    if ((noOfPageItem + '').indexOf(':') > -1) {
      this.noOfPageItem = noOfPageItem.split(':')[1].trim();
      currentPage = 1;
    } else {
      this.noOfPageItem = noOfPageItem;
    }
    this.currentPage = currentPage;
    let pageOptions = {
      currentPage: this.currentPage,
      noOfPageItem: this.noOfPageItem
    };
    this.pagination(pageOptions, null)
  }
  /*
     * Pagination is done on no of items in one page and current page
     */
  pagination(pageOptions, pageNo, popUpObj?: any) {
    let memberSummary: any = JSON.parse(atob(localStorage.getItem('memberSummary')));
    const eventStart = moment(this.startDate).utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    const eventEnd = moment(this.endDate).utcOffset(this.timezoneOffset).set({ 'hour': 24, 'second': 0, 'minute': 0, 'millisecond': 0 });
    if (eventStart.isBefore(eventEnd)) {
      //  this.filterState = this.filterPara;
      if (pageOptions) {
        this.pageOptions = pageOptions;
      }
      let requestObject = {} as any;
      requestObject = this.setVendorIdAsPerRole(pageNo);
      // requestObject.startDate = eventStart;
      // requestObject.endDate = eventEnd;
      requestObject.startDate = this.startDate;
      requestObject.endDate = this.endDate;
      requestObject.memberId = memberSummary.memberId,
        this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
      this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED;

      if ((this.searchMember + '').trim()) {
        requestObject['filters'].push({
          type: 'search',
          values: this.searchMember
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
      }
      localStorage.setItem('selectedStartDate', requestObject.startDate);
      localStorage.setItem('selectedEndDate', requestObject.endDate);
      this.getMemberVisitDetails(requestObject);
    } else {
      this.loaderEvent.fire(true);
      if (popUpObj) {
        this.popUpMessage = CONSTANT_MESSAGES.START_DATE_LESS_ERROR_MESSAGE;
        popUpObj.showChildModal();
      }
    }
  }

  setVendorIdAsPerRole(pageNo) {
    let requestObject = {
      'vendorId': '',
      perPage: this.pageOptions.noOfPageItem,
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    if (this.vendor.role === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      requestObject['vendorId'] = this.vendor._id;
    } else if (this.vendor.role === CONSTANT_VALUES.SUPER_ADMIN) {
      let subVendor = this.vendor.subVendors[0];
      requestObject['vendorId'] = subVendor._id;
    } else if (this.vendor.role === CONSTANT_VALUES.ROLE_STAFF) {
      requestObject['vendorId'] = this.vendor.vendorId;
    } 
    return requestObject;
  }

  onDateSelect(popUpObj) {

    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1, popUpObj);
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.pagination(this.pageOptions, 1), popUpObj;
      }
      this.exp = !this.exp;
    }
  }

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(bool => {
        this.shouldSlide = bool;
      });
  }
  enableEdit(index: number) {
    this.editRowIndex = index;
  }

  disableEdit() {
    this.editRowIndex = -1;
  }

  editTotalSpent(value: any, item: any) {
    if (!value || value == 0) {
      return;
    }
    item.amountSpent = parseFloat(value);
    if (!isNaN(item.amountSpent) && !isNaN(item.discount) && item.discount && item.amountSpent) {
      item.amountSaved = (item.amountSpent * item.discount) / 100;
    } else {
      item.amountSaved = 0;
    }
    if (item.amountSaved > 0) {
      item.amountSaved = Number(item.amountSaved).toFixed(2);
    }
    if (item.amountSpent > 0) {
      item.amountSpent = Number(item.amountSpent).toFixed(2);
    }
    try {
      this.loaderEvent.fire(false);
      let that = this;
      let request = {
        _id: item._id,
        totalSpent: item.amountSpent,
        totalSaved: item.amountSaved
      }
      this.loyaltyService.updateTotalSpent(request).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.editRowIndex = -1;
          this.loaderEvent.fire(true);
        }
      }).catch((err) => {
        this.popUpMessage = err;
        this.loaderEvent.fire(true);
      });
    } catch (e) {
      console.log(e);
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/loyalty/summary-details/summary-detail.component.ts